import { getAPI, postAPI, putAPI } from "../../api/api"
import { REACT_APP_CONTRACT, REACT_APP_CUSTOMER, REACT_APP_JOB } from "../../utils/common"

export async function contractMetadata(body: any) {
    const Details = putAPI(REACT_APP_CONTRACT + '/contract-metadata', body)
    return Details
}

export async function terminateContract(body: any) {
    const Details = postAPI(REACT_APP_CONTRACT + '/contract-terminate', body)
    return Details
}

export async function previousContractDetails(body: any) {
    const Details = postAPI(REACT_APP_CONTRACT + '/contract-metadata-history', body)
    return Details
}

export async function updateProject(body: any) {
    const Details = putAPI(REACT_APP_JOB + '/project', body)
    return Details
}

export async function getContractMetadataHistory(body: any) {
    const Details = postAPI( REACT_APP_CONTRACT + '/contract-metadata-history', body)
    return Details
}

export async function getProjects(companyId: string) {
    const Details = getAPI(REACT_APP_CUSTOMER + `/project-list/${companyId}`)
    return Details
}

export async function getProjectDetails(projectId: string) {
    const Details = getAPI(REACT_APP_CUSTOMER + `/project-details/${projectId}`)
    return Details
}

